import AwardCard from "components/DynamicComponent/atoms/AwardCard"

export default function AwardsAndMembershipsGrid({ blok }) {
  return (
    <section className="px-5 py-12 bg-highlight-tint">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-center text-primary">{blok.heading}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 pt-8">
          {blok.cards.map((card) => (
            <AwardCard key={card._uid} blok={card} />
          ))}
        </div>
      </div>
    </section>
  )
}
